import PlatformAgentLog from './PlatformAgentLog';

export default {
  PlatformAgentLog,
};
